// extracted by mini-css-extract-plugin
export default {"formSuccess":"FormSuccess_formSuccess__+r7Rs","title":"FormSuccess_title__Ajb7t","text":"FormSuccess_text__xZZq3","divider":"FormSuccess_divider__fLRAy"};